import {
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Typography,
  Button,
} from "@mui/material";
import React from "react";
import project1 from "../image/dot.png";
import SingleProject from "./SingleProject";
import pic1 from "../image/dot2.png";
import pic2 from "../image/health.png";
import pic3 from "../image/tourpng.png";
const service = [
  {
    id: 1,
    pic: pic1,
    title: "Dot-Baba-Shop",
    live: "https://dot-baba.web.app/",
    text: "A fully functional,full-stack web appbased on MERN This is an e-commerce nich project based web app  where anyone who is logged on the website can order  his choiceable car and can also view their order on the   Dashboard pase  -It has a customized admin panel,an admin can delete  Products,add additional products,remove order and  Also create a new admin",
  },
  {
    id: 2,
    pic: pic3,
    title: "Travel-Guro",
    live: "https://fucas-49839.web.app/",
    text: "-A fully functional,full-stack web app  based on MERN  .This is a tourism based web app where a person can   booking a choiceable place where he want to visit   .It has a customized admin panel,an admin can delete   Products,add additional products,remove order and  Also create a new admin",
  },
  {
    id: 3,
    pic: pic2,
    title: "Pro-Active",
    live: "https://health-realated.web.app/",
    text: "-A fully functional,full-stack web app  based on MERN  .This is a hospital based web app where a person can booking a schedule of a doctor",
  },
];
const Myproject = () => {
  return (
    <>
      <h1 className="text-center my-5">
        My Protfolio
        <hr className="mx-auto w-25" />
      </h1>

      <div className="row">
        <div className="col-md-10 col-10 row mx-auto ">
          {service.map((item) => (
            <SingleProject project={item}></SingleProject>
          ))}
        </div>
      </div>
    </>
  );
};

export default Myproject;
